<template>
  <div class="my-3">
    <h4 class="mb-3">Mail Queue</h4>

    <b-table
      hover
      fixed
      stacked="lg"
      :items="mailQueues"
      :fields="fields"
    >
      <template slot="state" slot-scope="data">
        {{data.item.state|stateName}}
      </template>

      <template slot="updated_at" slot-scope="data">
        <time :datetime="data.item.updated_at">{{data.item.updated_at|formatDate}}</time>
      </template>
    </b-table>

    <b-container>
      <b-row>
        <b-col>
          <b-alert show variant="info" v-if="mailQueues.length === 0">
            No mail is queued at this time.
          </b-alert>
        </b-col>
      </b-row>
    </b-container>

    <b-pagination-nav
      :number-of-pages="mailQueuesTotalPages"
      align="center"
      hide-goto-end-buttons
      hide-ellipsis
      hide-value
      :limit="1"
      v-if="mailQueues.length"
    ></b-pagination-nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '../store'
import moment from 'moment'

export default {
  beforeRouteEnter(to, from, next) {
    let page = to.query.page || 1

    return Promise.all([
      store.dispatch('mail_queues/fetchAll', { id: to.params.id, page })
    ])
      .then(next)
  },

  data() {
    return {
      pageTitle: 'Mail Queue',
      fields: [
        { key: 'state', label: 'State' },
        { key: 'updated_at', label: 'Last Updated' }
      ]
    }
  },

  computed: {
    ...mapState('campaigns', [
      'campaign'
    ]),

    ...mapState('mail_queues', [
      'mailQueues',
      'mailQueuesPage',
      'mailQueuesTotalPages'
    ])
  },

  filters: {
    formatDate(val) {
      return moment(val).format('MMM DD YYYY')
    },

    stateName(val) {
      return {
        'unsent': 'Unsent',
        'in_progress': 'In Progress',
        'sent': 'Sent'
      }[val]
    }
  }
}
</script>
